import Vue from 'vue'
import {
  http
} from 'public/utils/http'

// 实例化组件并插入评价弹窗
const openAppraiseModule = (tag, data) => {
  return new Promise(async (resolve) => {
    try {
      const appraiseModule = await import(/* webpackChunkName: "public-appraise-module" */ '@/layout/components/module-appraise.vue')
      const AppraiseRes = Vue.extend(appraiseModule.default)
      const appraiseCom = new AppraiseRes({
        propsData: {
          tag: tag,
          type: data
        }
      }).$mount()
      document.body.appendChild(appraiseCom.$el)
      // 评价弹窗组件添加
      appraiseCom.closeCallBack = function() {
        return resolve()
      }
    } catch (error) {
      console.log(error)
      return resolve()
    }
  })
}
// 获取评价弹窗配置信息
const getAppraiseConfig = async (tag) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await http('fdb.feedback.popUpCheck', {
        menuId: tag.menuId
      }, {
        axios: {
          headers: { 'X-menu-id': '2820215716730110' }
        }
      })
      if (data === 1 || data === 2) {
        return reject(data)
      } else {
        return resolve()
      }
    } catch (error) {
      console.log(error)
      return resolve()
    }
  })
}

export const checkAppraise = function(tag, route) {
  return new Promise((resolve) => {
    try {
      if (tag.path === route.fullPath) {
        Promise.race([
          getAppraiseConfig(tag),
          new Promise((resolve) => {
            setTimeout(() => {
              console.log('超时')
              return resolve()
            }, 200)
          })
        ]).then(() => {
          console.log('resolve')
          return resolve()
        }, async (data) => {
          console.log('reject')
          await openAppraiseModule(tag, data)
          return resolve()
        })
      } else {
        return resolve()
      }
    } catch (error) {
      return resolve()
    }
  })
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/check-appraise.js